import { VideoSchema } from '~/lib';
import { VideoMetadata } from './Video';

const secondsToISO8601 = (seconds?: number): string | undefined => {
    if (seconds == null) return;

    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    let result = 'PT';

    if (h) result += `${h}H`;
    if (m) result += `${m}M`;
    if (s || (!h && !m)) result += `${s}S`;

    return result;
};

const formatUploadDate = (date?: string) => {
    if (!date) return undefined;

    const d = new Date(date);

    return d.toISOString();
};

export const extractVideoMetadataFromModule = (props: VideoSchema): VideoMetadata => {
    return {
        uploadDate: formatUploadDate(props.videoPublishDate),
        name: props.videoTitle ?? props.videoFile?.name,
        description: props.videoDescription,
        duration: secondsToISO8601(props.videoDuration),
        thumbnailUrl: props.videoThumbnail?.src,
        contentUrl: props.videoFile?.src,
        embedUrl: props.videoFile?.src,
        encodingFormat: props.videoFile?.extension,
    };
};
